//import { DropzoneArea, DropzoneAreaProps } from 'material-ui-dropzone';
import { DropzoneArea, DropzoneAreaProps } from 'react-mui-dropzone';
import './dropzone.css';

export interface DropzoneCustomProps extends DropzoneAreaProps {
  readonly: boolean;
  initialFiles: Array<any>;
  dropzoneClass: string;
  variant: 'one' | 'two';
}

const Dropzone = (props: DropzoneCustomProps) => {
  const { readonly, initialFiles, dropzoneClass, variant, ...other } = props,
  filesToUrl = () =>
    initialFiles.map(file => typeof file === 'object' ? URL.createObjectURL(file) : file);


  return (
    <DropzoneArea
      dropzoneClass={`ds-dropzone-${variant} ${readonly ? 'readonly' : ''} ${dropzoneClass}`}
      initialFiles={filesToUrl()}
      {...other}
    />
  );
};

Dropzone.defaultProps = {
  readonly: false,
  variant: 'one',
  dropzoneClass: '',
  initialFiles: [],
};

export default Dropzone;

